// extracted by mini-css-extract-plugin
export default {"wrapper":"ChapterNavigationCard_wrapper__wEWxL","title":"ChapterNavigationCard_title__O8xFb","description":"ChapterNavigationCard_description__wEV00"};